import React, { Component } from "react";
import { Checkbox } from "antd";

class TandC extends Component {
  render() {
    return (
      <>
        <div className="row tnc">
          <div className="col-lg-12 col-md-12">
            <div className="text-center instructions-font-size">
              <label>
                <label className="instructions-text">
                  <input
                    type="checkbox"
                    id="tandc"
                    className="dark-checkbox"
                    onChange={(e) => this.props.onChange(e.target.checked)}
                  />
                  <b>
                    I/We hereby declare my / our acceptance for the same and
                    certify that the information submitted in this customer
                    registration application is true and correct to the best of
                    my/our knowledge. I / We further understand that any false
                    statements observed at the later stage may result in denial
                    or revocation of our customer registration with AM/NS India
                    group.
                  </b>
                </label>
              </label>
              <br />
              <br />
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default TandC;
